module.exports = __webpack_public_path__ + "media/images/bg/patterns/blog-949d05e94fa3d376c49068d2d833757b.svg";